import React from 'react'
import Label from '../atoms/Label'
import './SelectDropdown.css'

const SelectDropdown = ({ 
  label, 
  value, 
  onChange, 
  options = [], 
  placeholder = 'Select an option', 
  required = false, 
  id = '',
  className = '',
  ...props 
}) => {
  const classes = [
    'select-dropdown',
    className
  ].filter(Boolean).join(' ')

  return (
    <div className={classes} {...props}>
      {label && (
        <Label htmlFor={id} required={required}>
          {label}
        </Label>
      )}
      <select
        id={id}
        className="select-dropdown-input"
        value={value}
        onChange={onChange}
        required={required}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default SelectDropdown
